async function bootstrap() {
  const initApp = await import(/* webpackChunkName: 'application' */ "@modules/app-module");

  initApp.default();
}

bootstrap();
